import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Discount"],
});

const discountApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSchoolDiscounts: builder.query({
      query: () => "/fees/discount/school",
      providesTags: ["Discount"],
    }),
    createDiscount: builder.mutation({
      query: (values) => ({
        url: "/fees/discount",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Discount"],
    }),
    updateDiscount: builder.mutation({
      query: ({ id, ...values }) => ({
        url: `/fees/discount/${id}`,
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Discount"],
    }),
    deleteDiscount: builder.mutation({
      query: (id) => ({
        url: `/fees/discount/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Discount"],
    }),
    applyDiscount: builder.mutation({
      query: (values) => ({
        url: "/fees/invoice/discount",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Invoice"],
    }),
    removeInvoiceDiscount: builder.mutation({
      query: (invoiceId) => ({
        url: `/fees/invoice/${invoiceId}/discount`,
        method: "DELETE",
      }),
      invalidatesTags: ["Invoice"],
    }),
  }),
});

export const {
  useGetSchoolDiscountsQuery,
  useCreateDiscountMutation,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
  useApplyDiscountMutation,
  useRemoveInvoiceDiscountMutation,
} = discountApiSlice;
